import { fg } from '@atlaskit/platform-feature-flags/fg';

const HELP_HUB_TYPE = 'HELP_HUB';
export const HUB_ROUTE_FAMILY = 'hub';
export const LEGACY_ROUTE_FAMILY = 'legacy';

export const getHelpCenterRouteFamily = (
	helpCenterType: unknown,
	// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
	hubsEnabled = fg('enable-jsm-in-hubs'),
): typeof HUB_ROUTE_FAMILY | typeof LEGACY_ROUTE_FAMILY => {
	// Missing and unrecognised types retain the existing legacy routing behaviour.
	return hubsEnabled && helpCenterType === HELP_HUB_TYPE ? HUB_ROUTE_FAMILY : LEGACY_ROUTE_FAMILY;
};
